import React from 'react'
import About from './components/about'
import Header from './components/Header'
import Footer from './components/footer'
import { useLocation } from 'react-router-dom'

const AboutUs = () => {
  const location = useLocation()
  return (
    <div>
        <Header />
        <div 
        id='about'
        style={{ backgroundColor: 'whitesmoke', 
        height: `${location.pathname == '/about' ? '99vh' : 'auto'}` 
      }}
        >
        <h3 className='ms-2 pt-3' > <b> <i>  About BSC </i></b> </h3>
        <About />
        </div>
        {
          location.pathname == '/about' &&
          <Footer />
          }
    </div>


  )
}

export default AboutUs